import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {
    useLazyGetMeQuery,
    useLazyGetUserRoleQuery,
    useLoginUserMutation
} from '../../redux/api/auth';
import {setAccessToken, setUser} from '../../redux/reducers/authSlice';
import {selectAuthData} from '../../redux/selectors/auth';
import LandingPageNav from "../../Components/LandingPageNav/index.jsx";
import XFormInput from "../../Components/Utils/Form/XFormInput/index.jsx";
import {emailValidator} from "../../Utils/index.js";
import {FormProvider, useForm} from "react-hook-form";
import Button from "../../Components/Utils/Button/index.jsx";
import inputTypes from "../../Components/Utils/Form/FormInput/inputTypes.jsx";
import {setUserType} from "../../redux/reducers/userTypeSlice";

import './style.scss';

function Login({onSuccess = () => {}, noRedirect = false}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {user: {email} = {}} = useSelector(selectAuthData);

    const [loginUser, {data, isLoading, error, isSuccess}] = useLoginUserMutation();

    const [getMe, meProfile] = useLazyGetMeQuery();
    const [getRole, userRole] = useLazyGetUserRoleQuery()

    const [errorText, setErrorText] = React.useState('');
    const {t} = useTranslation();
    const form = useForm()
    const {handleSubmit, register, getValues, formState: {errors}} = form

    useEffect(() => {
        if (email) {
            !noRedirect ? navigate('/dashboard') : null;
        }
    }, [email]);

    useEffect(()=>{
        dispatch(setUser(meProfile?.data?.userProfile))
    },[meProfile?.status])


    useEffect(() => {
        if (error) {
            setErrorText(error.data.error?.message);
        }
    }, [error]);

    const submitLoginForm = async (values) => {
         loginUser({
            email: values.email,
            password: values.password
        }).then((response)=>{
              dispatch(setAccessToken(response.data.tokens))
             getMe().then((result)=>{
                 getRole(result?.data?.userProfile.id).then((result)=>{
                     dispatch(setUserType(result.data))
                 })
             })
         });
    };

    const onClickRegister = () => {
        navigate('/register');
    };

    return (
        <>
            <LandingPageNav/>
            <div className='login'>
                <FormProvider {...form} >
                    <form className='login__form' onSubmit={handleSubmit(submitLoginForm)}>
                        <div className='login__text login__title'><b>{t('welcome_back')}</b></div>
                        <p className='register__text'>{t('welcome_back_instructions')}</p>
                        <XFormInput
                            labelClass={'label_align_left'}
                            id={'email'}
                            type={inputTypes.text}
                            name={'email'}
                            label={t('email')}
                            placeholder='example@email.com'
                            ref={register('email', {
                                required: 'error_field_required',
                                validate: emailValidator
                            })}
                        />
                        <XFormInput
                            labelClass={'label_align_left'}
                            id="password"
                            name="password"
                            label={t('password')}
                            type={inputTypes.password}
                            placeholder={t('enter_password')}
                            ref={register('password', {
                                required: 'error_field_required',
                            })}
                        />
                        <Button className={'button__charlie'} type='submit' disabled={isLoading}> {t('login')}</Button>
                    </form>
                </FormProvider>
                <div className='login__error-text'>{errorText}</div>
                <div className='login__vertical-container login__login-container'>
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    <label className='login__text'>{t('no_account_question')}</label>
                    <Button className={'button__charlie'} onClick={onClickRegister}
                            disabled={isLoading}> {t('register')}</Button>
                </div>
            </div>
        </>
    );
}

export default Login;
